import React from "react";
import { Card } from "antd";

const FormSummaryLayout = props => {
    const { children } = props;
    return (
        <Card
            bordered
            style={{
                padding: "1rem 0.5rem",
                borderRadius: "5px",
                minHeight: "300px",
                backgroundColor: "rgba(0,0,0,0.01)",
            }}
        >
            {children}
        </Card>
    );
};

export default FormSummaryLayout;
